import { noop } from 'lodash'
import useActionGuard from 'hooks/useActionGuard'
import { CreatePost } from '@wellesley/openapi'
import { useIsMobile } from '@wellesley/ui'
import { FC, ReactNode } from 'react'

import { FooterProps } from '../types'
import MobileBottomModal from '../../../../mobile/MobileBottomModal'

import MessageButton from './MessageButton'
import ReplyMobileForm from '../ReplyMobileForm'

type TCommentControl = Pick<
  FooterProps,
  | 'feed'
  | 'isReply'
  | 'canComment'
  | 'isCommentForm'
  | 'isDisabledCommentOption'
  | 'userMentionSearchScope'
> & {
  isOpenComment: boolean
  readonly?: boolean
  customCommentContent?: ReactNode
  onSubmit(this: void, data: CreatePost): Promise<void>
  onOpenChange(this: void): void
}

const CommentControl: FC<TCommentControl> = (props) => {
  const {
    feed,
    onSubmit,
    onOpenChange,
    isDisabledCommentOption,
    readonly,
    userMentionSearchScope,
  } = props

  const isMobile = useIsMobile()
  const { isDisabled, guardedAction } = useActionGuard()

  const handleAddComment = guardedAction(onOpenChange)

  if (!feed.settings.commentsEnabled) return null

  if (isMobile) {
    return (
      <MobileBottomModal
        className="p-0"
        childrenClassName="!p-0"
        renderToggler={(toggle, isOpen) => (
          <MessageButton
            {...props}
            isDisabled={isDisabled}
            readonly={readonly}
            isOpenComment={isOpen}
            handler={readonly ? noop : guardedAction(toggle)}
          />
        )}
        renderContent={({ setOpen }) => (
          <ReplyMobileForm
            feed={feed}
            autoFocus={true}
            isDisabledCommentOption={isDisabledCommentOption}
            userMentionSearchScope={userMentionSearchScope}
            onSubmit={async (data: CreatePost) => {
              await onSubmit(data)
              setOpen(false)
            }}
            onClose={() => setOpen(false)}
          />
        )}
      />
    )
  }

  return (
    <MessageButton
      {...props}
      isReply={false}
      isDisabled={isDisabled}
      readonly={props.readonly}
      handler={props.readonly ? noop : handleAddComment}
    />
  )
}

export default CommentControl
